@if (yearlyBilling) {
  <order-summary-row
    [item]="{
      description: planItem?.description,
      amount: planItem?.amount / 100,
      note:
        '[price] x [employees] employees x 12 months'
        | translate
        | translationParams
          : { price: planItem?.unit_amount / 100 / 12 | subscriptionCurrency, employees: planItem?.quantity }
    }"
    [extraItem]="
      planItem?.discount_amount
        ? {
            description: 'Discount' | translate,
            amount: (planItem?.discount_amount * -1) / 100
          }
        : null
    "
  />
} @else {
  <order-summary-row
    [item]="{
      description: planItem?.description,
      amount: planItem?.amount / 100,
      note:
        '[price] x [employees] employees x 1 month'
        | translate
        | translationParams
          : {
              price: planItem?.unit_amount / 100 | subscriptionCurrency,
              employees: planItem?.quantity ? planItem?.quantity : 0
            }
    }"
    [extraItem]="
      planItem?.discount_amount
        ? {
            description: 'Discount' | translate,
            amount: (planItem?.discount_amount * -1) / 100
          }
        : null
    "
  />
}
@if (hasIntegrationPlus) {
  @if (yearlyBilling) {
    <order-summary-row
      [item]="{
        description: 'App Center Plus' | translate,
        amount: integrationPlusPrice,
        note:
          '[price] x 12 months'
          | translate
          | translationParams: { price: integrationPlusPrice / 12 | subscriptionCurrency }
      }"
    />
  } @else {
    <order-summary-row
      [item]="{
        description: 'App Center Plus' | translate,
        amount: integrationPlusPrice,
        note:
          '[price] x 1 month' | translate | translationParams: { price: integrationPlusPrice | subscriptionCurrency }
      }"
    />
  }
}

<hr class="m-0 border border-solid border-grey-200" />

<!-- Subtotal -->
<order-summary-row
  [item]="{
    description: 'Subtotal' | translate,
    amount: estimates.sub_total
  }"
>
</order-summary-row>

<!-- VAT -->
<order-summary-row
  [item]="{
    description: 'VAT' | translate,
    amount: estimates.tax_amount,
    note: vatNote | translate | translationParams: { countryCode, vatPercentage }
  }"
>
</order-summary-row>

<!-- Total -->
@if (yearlyBilling) {
  <order-summary-row
    [item]="{
      description: 'Total per year' | translate,
      note:
        'Due on [date], then every year'
        | translate
        | translationParams
          : {
              date: estimates.next_billing_date | localeDate: { year: 'numeric', month: 'long', day: 'numeric' }
            },
      amount: estimates.total
    }"
  />
} @else {
  <order-summary-row
    [item]="{
      description:
        'Total due on [date]'
        | translate
        | translationParams
          : {
              date: estimates.next_billing_date | localeDate: { year: 'numeric', month: 'long', day: 'numeric' }
            },
      amount: estimates.total
    }"
  />
}
